import { useEffect, useState } from "react";
import { PaymentMethod } from "./interfaces";
import { formatCost, formatDatetime, validateAwb } from "../../../utils";
import useStorageDays from "../../counter/import/useStorageDays";
import useStorage from '../../counter/import/useStorage';
import moment from "moment";
import { MinCharges } from "../../../globals/interfaces";
import apiClient from "../../../apiClient";
import usePiecesWeight from "../../counter/import/usePiecesWeight";

export default function useStorageData (
    s_mawb: string, 
    s_hawb: string,
    s_payment_method: PaymentMethod, 
    s_payment_type: string,
    f_amount: number,
    s_unit: string
) {

    const currentDate = moment().format('YYYY-MM-DD');
    const [ffms, setFfms] = useState([]);
    const [fhls, setFhls] = useState([]);
    const [minCharges, setMinCharges] = useState<MinCharges>({
        f_import_min_charge: 0, 
        f_import_per_kg: 0
    });

    useEffect(() => {
        if (!validateAwb(s_mawb) || s_payment_type !== 'STORAGE') {
            return;
        }

        const getAdditionalStorageData = async () => {
            try {
                const res = await apiClient.get(`/payment/additional-storage-data?s_mawb=${s_mawb}&s_unit=${s_unit}`);
                const { ffms, fhls, minCharges } = res.data;
                for (const ffm of ffms) {
                    ffm.selected = true;
                }
                setFfms(ffms);
                setFhls(fhls);
                setMinCharges(minCharges);
            } catch (err) {
                alert(err);
            }
        }

        getAdditionalStorageData();
    }, [s_mawb, s_payment_method, s_payment_type]);

    const { lastArrivalDate, setLastArrivalDate, storageDays } = useStorageDays(
        ffms, ffms.length === 0, s_mawb, '', s_unit, true, currentDate
    );

    if (!moment(lastArrivalDate).isValid()) {
        setLastArrivalDate(currentDate);
    }

    const { weight } = usePiecesWeight(ffms, fhls, Boolean(s_hawb), s_hawb);

    const { dailyStorage, totalStorage } = useStorage(
        Number(weight), 
        storageDays, 
        minCharges.f_import_per_kg, 
        minCharges.f_import_min_charge
    );

    const totalStorageAmount = formatCost(totalStorage);
    const storageText = `Amount ${formatCost(f_amount)}.\n Daily charge of ${formatCost(dailyStorage)} for ${storageDays} days is a total of ${totalStorageAmount}.`;
    const storageSmsText = `System total: ${totalStorageAmount}. Employee asking to charge ${formatCost(f_amount)}.`;

    // console.log({minCharges, lastArrivalDate, storageDays, weight, dailyStorage, totalStorage, totalStorageAmount});
    // per KW, consider switching FFM weight to look at FWB weight instead to prevent weight duplication

    return {
        storageAmount: totalStorageAmount,
        storageText,
        storageSmsText
    }
}